import { JSX } from 'react'

import logo from '../../assets/img/star.svg'

export const StartIcon = (): JSX.Element => {
  return <img src={logo} height="20" alt="star" id="starIcon" />
}
